module.exports = __webpack_public_path__ + "static/media/elife-school-2024-4.0db067cc.gif";